var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    _c("section", [
      _c(
        "button",
        {
          staticClass: "btn btn-primary",
          on: {
            click: function($event) {
              _vm.visible = !_vm.visible
            }
          }
        },
        [_vm._v("Merge User")]
      )
    ]),
    _vm._v(" "),
    _c("section", [
      _vm.visible
        ? _c("div", { staticClass: "container" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row" },
              [
                _c("search-bar", {
                  attrs: { name: "find", close_search_action: true },
                  on: {
                    close_search_event: _vm.closedSearch,
                    search_event: _vm.search_event
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.found_users.length > 0
              ? _c("div", { staticClass: "row" }, [
                  _c("h5", [
                    _vm._v("Displaying "),
                    _c("b", [_vm._v(_vm._s(_vm.found_users.length))]),
                    _vm._v(" users")
                  ]),
                  _vm._v(" "),
                  _c(
                    "table",
                    { staticClass: "table table-bordered table-responsive-sm" },
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(_vm.found_users, function(user) {
                          return _c("tr", [
                            _c("td", [_vm._v(_vm._s(user.id))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(user.first_name))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(user.last_name))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(user.email))]),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-danger",
                                  on: {
                                    click: function($event) {
                                      _vm.requestMerge(user)
                                    }
                                  }
                                },
                                [_vm._v("Merge")]
                              )
                            ])
                          ])
                        })
                      )
                    ]
                  )
                ])
              : _vm.has_searched
                ? _c("div", { staticClass: "row" }, [
                    _c("span", [_vm._v("(no results)")])
                  ])
                : _c("div", { staticClass: "row" }, [
                    _c("span", [_vm._v("Please enter more than 2 characters")])
                  ])
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("section", [
      _c(
        "div",
        {
          staticClass: "modal-danger modal fade",
          attrs: {
            id: "confirmUserMergeModal",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "confirmUserMergeModalLabel",
            "aria-hidden": "true"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-full-height modal-top",
              attrs: { role: "document" }
            },
            [
              _c("div", { staticClass: "modal-content" }, [
                _vm._m(2),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _vm._m(3),
                  _vm._v(" "),
                  _c("div", { staticClass: "container" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-5" }, [
                        _c(
                          "table",
                          {
                            staticClass:
                              "table table-bordered table-responsive-sm"
                          },
                          [
                            _vm._m(4),
                            _vm._v(" "),
                            _c("tbody", [
                              _c("tr", [
                                _c("td", [_vm._v(_vm._s(_vm.this_user.id))]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(_vm._s(_vm.this_user.first_name))
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(_vm._s(_vm.this_user.last_name))
                                ]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(_vm.this_user.email))])
                              ])
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-2" }, [
                        _vm._v("\n\t\t\t\t\t\t\t\t\t>>>>\n\t\t\t\t\t\t\t\t")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-5" }, [
                        _vm.selected_user != null
                          ? _c(
                              "table",
                              {
                                staticClass:
                                  "table table-bordered table-responsive-sm"
                              },
                              [
                                _vm._m(5),
                                _vm._v(" "),
                                _c("tbody", [
                                  _c("tr", [
                                    _c("td", [
                                      _vm._v(_vm._s(_vm.selected_user.id))
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(_vm.selected_user.first_name)
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(_vm.selected_user.last_name)
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(_vm._s(_vm.selected_user.email))
                                    ])
                                  ])
                                ])
                              ]
                            )
                          : _vm._e()
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      attrs: { type: "button", "data-dismiss": "modal" }
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-danger",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: {
                        click: function($event) {
                          _vm.submitMerge()
                        }
                      }
                    },
                    [_vm._v("Merge")]
                  )
                ])
              ])
            ]
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("h5", [_vm._v("Type user email")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("id")]),
        _vm._v(" "),
        _c("th", [_vm._v("First Name")]),
        _vm._v(" "),
        _c("th", [_vm._v("Last Name")]),
        _vm._v(" "),
        _c("th", [_vm._v("Email")]),
        _vm._v(" "),
        _c("th", [_vm._v("Actions")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "h5",
        {
          staticClass: "modal-title",
          attrs: { id: "confirmUserMergeModalLabel" }
        },
        [_vm._v("Merge Users")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h5", [_vm._v("Are you sure you want to continue?")]),
      _vm._v(" "),
      _c("div", [
        _c("span", { staticClass: "font-weight-bold" }, [
          _vm._v("This action is irreversible")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("id")]),
        _vm._v(" "),
        _c("th", [_vm._v("First Name")]),
        _vm._v(" "),
        _c("th", [_vm._v("Last Name")]),
        _vm._v(" "),
        _c("th", [_vm._v("Email")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("id")]),
        _vm._v(" "),
        _c("th", [_vm._v("First Name")]),
        _vm._v(" "),
        _c("th", [_vm._v("Last Name")]),
        _vm._v(" "),
        _c("th", [_vm._v("Email")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3246980e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3246980e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./resources/assets/js/components/pages/users/MergeUsers.vue
// module id = 738
// module chunks = 0